import { IonIcon } from '@ionic/react';
import { callOutline, chatboxEllipsesOutline } from 'ionicons/icons';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { EmergencyContact, User } from '../../model/models';
import { AppContext } from '../../state/AppContextProvider';
import { Modal } from '../globals/Modal';

interface EmergencyTranslate {
  label: string;
  number: string;
}

export const EmergencyContacts: React.FC = () => {
  const { state } = useContext(AppContext);

  return (
    <Modal
      addClass={
        state.isConnected
          ? ''
          : 'fullscreen-modal w-full h-full top-0 left-0 z-50 !mr-0'
      }
      content={<EmergencyContactsContent user={state.user} />}
      ModalUrl={'/emergency'}
      backUrl=""
      hideCloseBtn={false}
    />
  );
};

const EmergencyContactsContent: React.FC<{ user: User | undefined }> = ({
  user,
}) => {
  const getContactsByType = (type: string) => {
    let emergencyList: Array<EmergencyContact> = [];
    if (
      user &&
      user.emergency_contacts &&
      Array.isArray(user.emergency_contacts)
    ) {
      emergencyList = user.emergency_contacts.filter(
        (contact) => contact.contact_type === type
      );
    }

    return EmergencyContactsToEmergencyTranslate(emergencyList);
  };

  const EmergencyContactsToEmergencyTranslate = (
    contactTab: Array<EmergencyContact>
  ) => {
    let ret: Array<EmergencyTranslate> = [];
    if (user) {
      if (user.acf.locale === 'fr_FR') {
        ret = contactTab.map((phone) => {
          return {
            number: phone.number,
            label: phone.title_fr,
          };
        });
      } else {
        ret = contactTab.map((phone) => {
          return {
            number: phone.number,
            label: phone.title_en,
          };
        });
      }
    }

    return ret;
  };

  const listEmail = getContactsByType('email');
  const listPhone = getContactsByType('phone');

  return (
    <div className="bg-white h-full md:h-auto modal-profile-content py-20 px-6 rounded-t-3xl md:rounded-3xl">
      <div className="profile-header center flex flex-col items-center bg-white">
        <div className="flex w-14 h-14 inset-4 justify-center items-center border border-transparent rounded-full text-white bg-secondary">
          <IonIcon
            className="w-7 h-7 text-white ios hydrated"
            icon={callOutline}
            role="img"
          />
        </div>
        <h2 className="font-semibold text-xl mt-4 text-black">
          <FormattedMessage id="Emergency Contacts" />
        </h2>
      </div>
      {listEmail.length > 0 || listPhone.length > 0 ? (
        <div className="h-4/5 mt-8">
          {listPhone.length > 0 && (
            <div className="flex flex-col justify-start items-start">
              <div className="flex flex-col justify-center items-center mt-2 w-full">
                {listPhone.map((phone, index) => (
                  <a
                    key={'phone_' + index}
                    className="flex justify-between items-center w-full py-4 border-b border-gray-300 bg-white"
                    href={`tel:${phone.number}`}
                  >
                    <div className="flex flex-col justify-start items-start w-11/12 break-words">
                      <span className="text-xs !text-black font-semibold">
                        {phone.label}
                      </span>
                      <span className="text-sm font-medium text-gray-400 w-fit">
                        {phone.number}
                      </span>
                    </div>
                    <div className="flex w-8 h-8 justify-center items-center bg-primary rounded-full text-white">
                      <IonIcon icon={callOutline} />
                    </div>
                  </a>
                ))}
              </div>
            </div>
          )}
          {listEmail.length > 0 && (
            <div className="flex flex-col justify-start items-start">
              <div className="flex flex-col justify-center items-center mt-2 w-full">
                {listEmail.map((email, index) => (
                  <a
                    key={'phone_' + index}
                    className="flex justify-between items-center w-full py-4 border-b border-gray-300 bg-white break-words"
                    href={`mailto:${email.number}`}
                  >
                    <div className="flex flex-col justify-start items-start w-11/12">
                      <span className="text-xs text-black font-semibold ">
                        {email.label}
                      </span>
                      <span className="text-sm font-medium text-gray-400 break-all overflow-auto w-11/12">
                        {email.number}
                      </span>
                    </div>
                    <div className="flex w-8 h-8 justify-center items-center bg-primary rounded-full text-white">
                      <IonIcon icon={chatboxEllipsesOutline} />
                    </div>
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="mt-2 text-center text-black">
          <FormattedMessage id="No emergency number" />
        </div>
      )}
    </div>
  );
};
